import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

/**
 * Breadcrumb navigation component
 */
export default function Breadcrumbs() {
  const location = useLocation();

  // Parse path into breadcrumb segments
  const pathSegments = location.pathname
    .split('/')
    .filter((segment) => segment && segment !== 'admin');

  // Generate breadcrumb items
  const breadcrumbs = pathSegments.map((segment, index) => {
    const path = `/admin/${pathSegments.slice(0, index + 1).join('/')}`;
    const label = segment
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    return { path, label };
  });

  // Don't show breadcrumbs on dashboard
  if (breadcrumbs.length === 0 || breadcrumbs[0].label === 'Dashboard') {
    return null;
  }

  return (
    <nav className="flex items-center gap-2 text-body-sm">
      {/* Home/Dashboard Link */}
      <Link
        to="/admin/dashboard"
        className="flex items-center gap-1 text-white/60 hover:text-white transition-colors"
      >
        <Home className="w-4 h-4" />
        <span>Dashboard</span>
      </Link>

      {/* Breadcrumb Items */}
      {breadcrumbs.map((crumb, index) => {
        const isLast = index === breadcrumbs.length - 1;

        return (
          <div key={crumb.path} className="flex items-center gap-2">
            <ChevronRight className="w-4 h-4 text-white/40" />
            {isLast ? (
              <span className="text-white font-medium">
                {crumb.label}
              </span>
            ) : (
              <Link
                to={crumb.path}
                className="text-white/60 hover:text-white transition-colors"
              >
                {crumb.label}
              </Link>
            )}
          </div>
        );
      })}
    </nav>
  );
}
